module.exports = __webpack_public_path__ + "img/measure.c5a815a2.jpg";